import React from 'react'
import PropTypes from 'prop-types'
import ImageTextCarousel from '@/components/image-text-carousel'

export const ImageTextCarouselBiulder = (props) => {
    return <ImageTextCarousel {...props} />
}

ImageTextCarouselBiulder.propTypes = {
    external: PropTypes.bool,
    header: PropTypes.string,
    subHeader: PropTypes.string,
    ctaPosition: PropTypes.string,
    buttonColor: PropTypes.string,
    buttonTextColor: PropTypes.string,
    contentType: PropTypes.string,
    ctaStyle: PropTypes.string,
    ctaText: PropTypes.string,
    link: PropTypes.shape({
        id: PropTypes.string,
        value: PropTypes.shape({
            data: PropTypes.shape({
                isSfraPage: PropTypes.bool,
                url: PropTypes.string
            })
        })
    }),
    external_link: PropTypes.shape({
        id: PropTypes.string,
        value: PropTypes.shape({
            data: PropTypes.shape({
                isSfraPage: PropTypes.bool,
                url: PropTypes.string
            })
        })
    }),
    carouselEnabledOnDesktop: PropTypes.bool,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            image: PropTypes.string,
            external: PropTypes.bool,
            external_link: PropTypes.shape({
                id: PropTypes.string,
                value: PropTypes.shape({
                    data: PropTypes.shape({
                        isSfraPage: PropTypes.bool,
                        url: PropTypes.string
                    })
                })
            }),
            link: PropTypes.shape({
                id: PropTypes.string,
                value: PropTypes.shape({
                    data: PropTypes.shape({
                        isSfraPage: PropTypes.bool,
                        url: PropTypes.string
                    })
                })
            }),
            text: PropTypes.string
        })
    )
}

export const ImageTextCarouselBiulderDefinition = {
    component: ImageTextCarouselBiulder,
    name: 'ImageTextCarousel',
    label: 'Image Text Carousel',
    enrich: true,
    inputs: [
        {
            name: 'header',
            type: 'text',
            helperText: 'The header for the carousel'
        },
        {
            name: 'contentType',
            type: 'string',
            enum: [
                {label: 'Logo images', value: 'logo'},
                {label: 'Icons with Text', value: 'icons'}
            ],
            defaultValue: 'image-left'
        },
        {
            name: 'ctaPosition',
            type: 'string',
            enum: [
                {label: 'Top', value: 'top'},
                {label: 'Bottom', value: 'bottom'}
            ],
            defaultValue: 'bottom',
            helperText: 'Position of the CTA'
        },
        {
            name: 'ctaStyle',
            type: 'string',
            enum: [
                {label: 'Button', value: 'button'},
                {label: 'Link', value: 'link'}
            ],
            defaultValue: 'button',
            helperText: 'Style of the CTA'
        },
        {
            name: 'buttonColor',
            type: 'color',
            helperText: 'Color of the button'
        },
        {
            name: 'buttonTextColor',
            type: 'color',
            helperText: 'Text color of the button'
        },
        {
            name: 'ctaText',
            type: 'string',
            defaultValue: 'Shop Now',
            helperText: 'The text for the CTA'
        },
        {
            name: 'external',
            type: 'boolean',
            defaultValue: false,
            helperText: 'Whether the link is external or internal.'
        },
        {
            name: 'external_link',
            type: 'reference',
            model: 'external-links',
            showIf: `options.get('external') === true`,
            helperText: 'The external link for the CTA.'
        },
        {
            name: 'link',
            type: 'reference',
            model: 'page',
            showIf: `options.get('external') === false`,
            helperText: 'The internal link for the CTA.'
        },

        {
            name: 'items',
            type: 'list',
            subFields: [
                {
                    name: 'image',
                    type: 'file',
                    helperText: 'Image for the item'
                },
                {
                    name: 'external',
                    type: 'boolean',
                    defaultValue: false,
                    helperText: 'Whether the link is external or internal.'
                },
                {
                    name: 'external_link',
                    type: 'reference',
                    model: 'external-links',
                    showIf: `options.get('external') === true`,
                    helperText: 'The external link for the column item.'
                },
                {
                    name: 'link',
                    type: 'reference',
                    model: 'page',
                    showIf: `options.get('external') === false`,
                    helperText: 'The internal link for the column item.'
                },
                {
                    name: 'text',
                    type: 'text',
                    helperText: 'The text for the icon item.'
                }
            ]
        }
    ]
}
